<template>
  <div class="order-food-entry">
    <div class="order-food-entry__container">
      <div class="order-food-entry__header">
        <div class="order-food-entry__header-left">
          <div class="order-food-entry__title">
            {{ $t('OrderFoodEntry.Title') }}
          </div>
        </div>
        <div class="order-food-entry__header-right">
          <!-- 設定（原社區會館管理） -->
          <el-button
            round
            @click="openCommunityDialog"
          >
            {{ $t('OrderFoodEntry.CommunityHallTitle') }}
          </el-button>
          <!-- 點餐使用項目管理 -->
          <el-button
            round
            @click="goToItemManagement"
          >
            {{ $t('OrderFoodEntry.ItemManagementTitle') }}
          </el-button>
        </div>
      </div>
      <div class="order-food-entry__content">
        <div class="order-food-entry__service-group">
          <!-- 櫃檯點餐 -->
          <div class="order-food-entry__service-item" @click="goToCounter">
            <div class="order-food-entry__service-item-icon">
              <img src="@/assets/img/orderfood/order-counter@3x.webp" alt="counter">
            </div>
            <div class="order-food-entry__service-item-title">
              {{ $t('OrderFoodEntry.CounterTitle') }}
            </div>
            <div class="order-food-entry__service-item-tip">
              {{ $t('OrderFoodEntry.CounterTip') }}
            </div>
          </div>
          <!-- 住戶點餐 -->
          <div
            v-if="isPickupEnabled"
            class="order-food-entry__service-item"
            @click="goToPickup"
          >
            <div class="order-food-entry__service-item-icon">
              <img src="@/assets/img/orderfood/receive-order@3x.webp" alt="pickup">
            </div>
            <div class="order-food-entry__service-item-title">
              {{ $t('OrderFoodEntry.PickupTitle') }}
            </div>
            <div class="order-food-entry__service-item-tip">
              {{ $t('OrderFoodEntry.PickupTip') }}
            </div>
          </div>
          <!-- 餐點訂單 -->
          <div class="order-food-entry__service-item" @click="goToManagement">
            <div class="order-food-entry__service-item-icon">
              <img src="@/assets/img/orderfood/food-order@3x.webp" alt="order-list">
            </div>
            <div class="order-food-entry__service-item-title">
              {{ $t('OrderFoodEntry.OrderListTitle') }}
            </div>
            <div class="order-food-entry__service-item-tip">
              {{ $t('OrderFoodEntry.OrderListTip') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <clubhouse-dialog
      v-model="isCommunityDialogVisible"
      @saved="handleClubhouseSaved"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ClubhouseDialog from './components/ClubhouseDialog.vue'

export default {
  name: 'OrderFoodEntry',
  components: {
    ClubhouseDialog
  },
  data () {
    return {
      // 控制設定 Dialog 顯示狀態
      isCommunityDialogVisible: false
    }
  },
  computed: {
    // 是否顯示「住戶取餐」入口（櫃檯＋APP＋通知取餐，isServiceEnabled 64）
    ...mapGetters({ isPickupEnabled: 'isCommunityOrderFoodAppPickupEnabled' })
  },
  methods: {
    openCommunityDialog () {
      this.isCommunityDialogVisible = true
    },
    // 前往點餐使用項目管理頁面
    goToItemManagement () {
      this.$router.push({ name: 'orderFoodItemManagement' })
    },
    // 前往櫃檯點餐頁面
    goToCounter () {
      this.$router.push({ name: 'orderFoodCounter' })
    },
    // 前往住戶取餐頁面
    goToPickup () {
      this.$router.push({ name: 'orderFoodPickup' })
    },
    handleClubhouseSaved () {
      // TODO: 成功儲存會館資訊後的提示（例如 this.$message.success）
    },
    // 前往餐點訂單頁面
    goToManagement () {
      this.$router.push({ name: 'orderFoodManagement' })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-food-entry {
  @include mainLayer();
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;

  &__container {
    min-width: 1140px;
    max-width: 90%;
    background-color: #fff;
    border-radius: 8px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    border-bottom: 1px solid #e5e4e4;

    &-left {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &-right {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &__title {
    font-size: map-get($fontSize, xx-large);
    font-weight: 600;
    color: #333
  }
  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 72px 0;
  }
  &__service-group {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
  }
  &__service-item {
    width: 210px;
    height: 210px;
    border-radius: 8px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #333;
    cursor: pointer;
    &:hover {
      background-color: #daf0eb;
    }

    &-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 60px;
      margin-bottom: 16px;

      & > img {
        width: 100%;
        height: 100%;
      }
    }
    &-title {
      font-size: map-get($fontSize, xxx-large);
      font-weight: 600;
      margin-bottom: 12px;
    }
    &-tip {
      font-size: map-get($fontSize, medium);
      color: #666;
    }
  }
}
</style>
